import React, { useState, useEffect } from "react";
import "./Header.scss";

import CubeLogo from "components/CubeLogo";
import PrimaryNav from "components/PrimaryNav";
import Search from "components/Search";

import UserPanel from "components/UserPanel";
import Button from "components/Button";

import * as ROUTES from "constants/routes";

import { withFirebase } from "components/Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";

const SignUp = () => (
  <div className="header-SignUp">
    <Button to={ROUTES.SIGN_IN}>Log In</Button>
    <Button to={ROUTES.SIGN_UP} type="primary">
      Create account
    </Button>
  </div>
);

const NormalNav = ({ search, fixed, user }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, [user]);

  return (
    <div className="Header" data-fixed={fixed} data-loaded={loaded}>
      <div className="L">
        <CubeLogo showcase size={64} />
        <PrimaryNav />
        {search && <Search />}
      </div>
      <div className="R">{user ? <UserPanel user={user} /> : <SignUp />}</div>
    </div>
  );
};

const Header = ({ search, fixed, location, firebase, authUser }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (authUser && user === null) {
      firebase
        .user(authUser.uid)
        .get()
        .then(response => {
          setUser(response.data());
        })
        .catch(console.error);
    }
  }, [authUser]);
  return (
    <>
      {location.pathname !== "/onboarding" ? (
        <NormalNav search={search} user={user} fixed={fixed} />
      ) : null}
    </>
  );
};

export default compose(
  withRouter,
  withFirebase
)(Header);
